(function(){
  'use strict';
  var track = document.getElementById('PcfTrack');
  if(!track) return;
  var prevBtn = document.getElementById('PcfPrev');
  var nextBtn = document.getElementById('PcfNext');
  var RAW = (window.PRAYASA_VIDEOS || []).slice();

  function shuffle(arr){
    for(var i = arr.length - 1; i > 0; i--){
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }

  var DATA = shuffle(RAW);
  var n = DATA.length;
  if(!n) return;

  var current = 0;
  var cards = [];
  var moved = false;
  var soundOn = false;

  var ICON_MUTED = '<path d="M11 5 6 9H3v6h3l5 4V5z"/><line x1="16" y1="9" x2="21" y2="15"/><line x1="21" y1="9" x2="16" y2="15"/>';
  var ICON_LOUD = '<path d="M11 5 6 9H3v6h3l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18 6a9 9 0 0 1 0 12"/>';

  function esc(s){ return String(s == null ? '' : s).replace(/"/g,'&quot;'); }

  function syncIcons(soundBtn, muted){
    if(!soundBtn) return;
    var off = soundBtn.querySelector('.pcf__ic-off');
    var on = soundBtn.querySelector('.pcf__ic-on');
    if(off) off.hidden = !muted;
    if(on) on.hidden = muted;
  }

  /* ---------- Fullscreen overlay ---------- */
  var fsWrap = null, fsStage = null, fsSoundBtn = null;
  var fsMedia = null, fsVideo = null;

  function buildOverlay(){
    if(fsWrap) return;
    fsWrap = document.createElement('div');
    fsWrap.className = 'pcf-fs';
    fsWrap.setAttribute('role', 'dialog');
    fsWrap.setAttribute('aria-modal', 'true');
    fsWrap.setAttribute('aria-label', 'Video');

    fsStage = document.createElement('div');
    fsStage.className = 'pcf-fs__stage';
    fsWrap.appendChild(fsStage);

    fsSoundBtn = document.createElement('button');
    fsSoundBtn.type = 'button';
    fsSoundBtn.className = 'pcf-fs__btn pcf-fs__sound';
    fsSoundBtn.setAttribute('aria-label', 'Toggle sound');
    fsSoundBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">' + ICON_MUTED + '</svg>';
    fsSoundBtn.addEventListener('click', function(e){
      e.stopPropagation();
      if(!fsVideo) return;
      fsVideo.muted = !fsVideo.muted;
      soundOn = !fsVideo.muted;
      if(!fsVideo.muted){
        var p = fsVideo.play();
        if(p && p.catch) p.catch(function(){});
      }
      paintFsSound();
    });
    fsWrap.appendChild(fsSoundBtn);

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'pcf-fs__btn pcf-fs__close';
    closeBtn.setAttribute('aria-label', 'Close video');
    closeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg>';
    closeBtn.addEventListener('click', function(e){ e.stopPropagation(); closeFs(); });
    fsWrap.appendChild(closeBtn);

    fsWrap.addEventListener('click', function(e){
      if(e.target === fsWrap || e.target === fsStage) closeFs();
    });

    document.body.appendChild(fsWrap);
  }

  function paintFsSound(){
    if(!fsSoundBtn || !fsVideo) return;
    var svg = fsSoundBtn.querySelector('svg');
    if(svg) svg.innerHTML = fsVideo.muted ? ICON_MUTED : ICON_LOUD;
  }

  function openFs(media){
    var video = media.querySelector('video');
    if(!video) return;
    buildOverlay();
    fsMedia = media;
    fsVideo = video;
    video.classList.remove('pcf__vid');
    video.setAttribute('controls', '');
    fsStage.appendChild(video);
    paintFsSound();
    document.body.classList.add('pcf-fs-open');
    requestAnimationFrame(function(){ fsWrap.classList.add('is-open'); });
    var p = video.play();
    if(p && p.catch) p.catch(function(){});
  }

  function closeFs(){
    if(!fsWrap || !fsVideo || !fsMedia) return;
    fsWrap.classList.remove('is-open');
    document.body.classList.remove('pcf-fs-open');
    var video = fsVideo, media = fsMedia;
    fsVideo = null; fsMedia = null;
    video.removeAttribute('controls');
    video.classList.add('pcf__vid');
    var anchor = media.querySelector('.pcf__sound');
    if(anchor) media.insertBefore(video, anchor); else media.appendChild(video);
    syncIcons(media.querySelector('.pcf__sound'), video.muted);
    var p = video.play();
    if(p && p.catch) p.catch(function(){});
  }

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && fsVideo) closeFs();
  });

  /* ---------- Cards ---------- */
  function buildCard(v, i){
    var card = document.createElement('div');
    card.className = 'pcf__card';
    card.setAttribute('data-index', i);

    var media = document.createElement('div');
    media.className = 'pcf__media';

    var poster = document.createElement('img');
    poster.className = 'pcf__poster';
    poster.src = v.poster || '';
    poster.alt = '';
    poster.loading = 'lazy';
    media.appendChild(poster);

    var fsBtn = document.createElement('button');
    fsBtn.type = 'button';
    fsBtn.className = 'pcf__ctl pcf__fs';
    fsBtn.setAttribute('aria-label', 'Play fullscreen');
    fsBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5"/></svg>';
    fsBtn.addEventListener('click', function(e){
      e.stopPropagation();
      e.preventDefault();
      openFs(media);
    });
    fsBtn.addEventListener('mousedown', function(e){ e.stopPropagation(); });
    fsBtn.addEventListener('touchstart', function(e){ e.stopPropagation(); }, {passive: true});
    media.appendChild(fsBtn);

    var soundBtn = document.createElement('button');
    soundBtn.type = 'button';
    soundBtn.className = 'pcf__ctl pcf__sound';
    soundBtn.setAttribute('aria-label', 'Toggle sound');
    soundBtn.innerHTML = '<svg class="pcf__ic-off" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">' + ICON_MUTED + '</svg><svg class="pcf__ic-on" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" hidden>' + ICON_LOUD + '</svg>';
    soundBtn.addEventListener('click', function(e){
      e.stopPropagation();
      e.preventDefault();
      var video = media.querySelector('video');
      if(!video) return;
      video.muted = !video.muted;
      soundOn = !video.muted;
      if(!video.muted){
        var p = video.play();
        if(p && p.catch) p.catch(function(){});
      }
      syncIcons(soundBtn, video.muted);
    });
    soundBtn.addEventListener('mousedown', function(e){ e.stopPropagation(); });
    soundBtn.addEventListener('touchstart', function(e){ e.stopPropagation(); }, {passive: true});
    media.appendChild(soundBtn);
    card.appendChild(media);

    if(v.handle && v.title){
      var shop = document.createElement('a');
      shop.className = 'pcf__shop';
      shop.href = '/collections/' + v.handle;
      shop.innerHTML = 'Shop ' + esc(v.title) + ' <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
      shop.addEventListener('click', function(e){ e.stopPropagation(); });
      card.appendChild(shop);
    } else {
      var tag = document.createElement('span');
      tag.className = 'pcf__tag';
      tag.textContent = 'Prayasa';
      card.appendChild(tag);
    }

    card.addEventListener('click', function(){
      if(moved) return;
      var idx = parseInt(card.getAttribute('data-index'), 10);
      if(idx !== normalize(current)) goTo(idx);
    });

    track.appendChild(card);
    return {card: card, media: media};
  }

  DATA.forEach(function(v, i){ cards.push(buildCard(v, i)); });

  function normalize(i){ return ((i % n) + n) % n; }

  function circDiff(i, cur){
    var d = i - cur;
    d = ((d % n) + n) % n;
    if(d > n / 2) d -= n;
    return d;
  }

  function metrics(){
    var w = window.innerWidth;
    if(w <= 520) return {cardW: 178, spacing: 140};
    if(w <= 820) return {cardW: 214, spacing: 174};
    return {cardW: 262, spacing: 203};
  }

  function attachVideo(media, v){
    if(media === fsMedia) return;
    if(media.querySelector('video')) return;
    var video = document.createElement('video');
    video.className = 'pcf__vid';
    video.muted = !soundOn;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.preload = 'auto';
    video.src = v.src;
    media.insertBefore(video, media.querySelector('.pcf__fs'));
    var soundBtn = media.querySelector('.pcf__sound');
    syncIcons(soundBtn, video.muted);
    var p = video.play();
    if(p && p.catch) p.catch(function(){
      video.muted = true;
      syncIcons(soundBtn, true);
      var p2 = video.play();
      if(p2 && p2.catch) p2.catch(function(){});
    });
  }

  function detachVideo(media, card){
    if(media === fsMedia) return;
    var video = media.querySelector('video');
    if(video){ video.pause(); video.remove(); }
    syncIcons(media.querySelector('.pcf__sound'), true);
  }

  function render(){
    var m = metrics();
    var cur = normalize(current);
    cards.forEach(function(entry, i){
      var card = entry.card, media = entry.media;
      var d = circDiff(i, cur);
      var absD = Math.abs(d);
      var isCenter = d === 0;
      card.classList.toggle('is-center', isCenter);
      if(isCenter){
        attachVideo(media, DATA[i]);
      } else {
        detachVideo(media, card);
      }
      card.style.width = m.cardW + 'px';
      card.style.marginLeft = (-m.cardW / 2) + 'px';
      if(absD > 4){
        card.style.opacity = '0';
        card.style.pointerEvents = 'none';
        card.style.zIndex = '1';
        card.style.transform = 'translateX(' + (d * m.spacing) + 'px) scale(.4)';
        media.style.filter = 'none';
        return;
      }
      var scale = Math.max(1 - absD * 0.16, 0.55);
      var opacity = Math.max(1 - absD * 0.24, 0.28);
      var blur = isCenter ? 0 : Math.min(absD * 1.3, 5);
      card.style.zIndex = String(100 - absD);
      card.style.opacity = String(opacity);
      card.style.pointerEvents = 'auto';
      media.style.filter = blur ? 'blur(' + blur + 'px)' : 'none';
      card.style.transform = 'translateX(' + (d * m.spacing) + 'px) scale(' + scale + ')';
    });
  }

  function goTo(i){
    current = i;
    render();
  }

  prevBtn && prevBtn.addEventListener('click', function(){ goTo(current - 1); });
  nextBtn && nextBtn.addEventListener('click', function(){ goTo(current + 1); });

  track.setAttribute('tabindex', '0');
  track.addEventListener('keydown', function(e){
    if(fsVideo) return;
    if(e.key === 'ArrowLeft'){ e.preventDefault(); goTo(current - 1); }
    else if(e.key === 'ArrowRight'){ e.preventDefault(); goTo(current + 1); }
  });

  var dragging = false, startX = 0;
  function pointerDown(e){
    if(e.target && e.target.closest && e.target.closest('.pcf__ctl')) return;
    dragging = true; moved = false;
    startX = (e.touches ? e.touches[0].clientX : e.clientX);
  }
  function pointerMove(e){
    if(!dragging) return;
    var x = (e.touches ? e.touches[0].clientX : e.clientX);
    if(Math.abs(x - startX) > 8) moved = true;
  }
  function pointerUp(e){
    if(!dragging) return;
    dragging = false;
    var x = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX);
    var dx = x - startX;
    var m = metrics();
    if(Math.abs(dx) > m.spacing / 3){
      moved = true;
      var steps = Math.round(dx / m.spacing) || (dx > 0 ? 1 : -1);
      steps = Math.max(-3, Math.min(3, steps));
      goTo(current - steps);
    }
    setTimeout(function(){ moved = false; }, 60);
  }
  track.addEventListener('mousedown', pointerDown);
  track.addEventListener('touchstart', pointerDown, {passive: true});
  window.addEventListener('mousemove', pointerMove);
  track.addEventListener('touchmove', pointerMove, {passive: true});
  window.addEventListener('mouseup', pointerUp);
  track.addEventListener('touchend', pointerUp);

  var resizeTimer;
  window.addEventListener('resize', function(){
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(render, 150);
  });

  render();
})();
